// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag-module__tag___2DO8p","content":"Tag-module__content___EJNr5"};